import { Pipe, PipeTransform } from '@angular/core';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { TranslateService } from '@ngx-translate/core';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';

@Pipe({
  name: 'enum'
})
export class EnumPipe implements PipeTransform {
  constructor(
    private readonly fuseTranslationLoaderService: FuseTranslationLoaderService,
    private readonly translateService: TranslateService
  ) {
    this.fuseTranslationLoaderService.loadJsonTranslations({ english, portuguese, spanish });
  }

  transform(value: string, entityType: string): string {
    value = value.split(/(?=[A-Z])/).map(s => s.toUpperCase()).join('_');
    const translateKey = `ENUM.${entityType.toUpperCase()}.${value}`;
    return this.translateService.instant(translateKey);
  }
}
